<template>
	<div>
		<van-nav-bar @click-left="onClickLeft" title="在线客服" left-arrow>
			<template #left>
				<van-icon name="../../../static/images/mobile/back.png" size="18" />
			</template>
		</van-nav-bar>
		<van-tabbar v-model="active">
			<van-tabbar-item to="/mobileHome">
				<span>首页</span>
				<template #icon="props">
					<img :src="props.active ? index.active : index.inactive" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item to="/mobileStudy">
				<span>班级</span>
				<template #icon="props">
					<img :src="props.active ? classes.active : classes.inactive" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item to="/mobileMy">
				<span>我的</span>
				<template #icon="props">
					<img :src="props.active ? my.active : my.inactive" />
				</template>
			</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
export default {
	data() {
		return {
			active: 2,
			index: {
				active: "../../../static/images/mobile/onIndex.png",
				inactive: "../../../static/images/mobile/index.png",
			},
			classes: {
				active: "../../../static/images/mobile/onClass.png",
				inactive: "../../../static/images/mobile/class.png",
			},
			my: {
				active: "../../../static/images/mobile/onMy.png",
				inactive: "../../../static/images/mobile/my.png",
			}, //table栏
		};
	},
	methods: {
		onClickLeft() {
			this.$router.go(-1);
		},
	},
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// MobileService.vue?76ccb7b3